import type { Commerce, CommerceConfiguration } from "@teqtank/commerce-contracts";
import { bootstrapCommerceRuntime } from "./runtime/bootstrap-commerce-runtime.js";
import {
    clearPersistedCommerceSession,
    type PersistedCommerceSessionTarget,
} from "./session/browser-commerce-session.js";
import { TEQTANK_COMMERCE_SDK_VERSION } from "./version.js";

/** Public entry point for creating isolated Teqtank Commerce SDK instances. */
export class TeqtankCommerce {
    private constructor() {
        // Static product entry point.
    }

    /**
     * Creates and fully initializes an isolated Commerce runtime.
     *
     * The promise resolves only after configuration, session, context and
     * runtime validation have completed successfully.
     */
    public static initialize(configuration: CommerceConfiguration): Promise<Commerce> {
        console.log("Initializing Teqtank Commerce SDK:", {
            version: TEQTANK_COMMERCE_SDK_VERSION,
            commerceKey: configuration.commerceKey,
            dataSource: configuration.dataSource,
        });
        return bootstrapCommerceRuntime(TEQTANK_COMMERCE_SDK_VERSION, configuration);
    }

    /** Clears the resumable browser session for one Gateway/key/source tuple. */
    public static clearPersistedSession(target: PersistedCommerceSessionTarget): Promise<void> {
        return clearPersistedCommerceSession(target);
    }
}
/** Creates and initializes an isolated Teqtank Commerce runtime. */
export function createCommerce(configuration: CommerceConfiguration): Promise<Commerce> {
    console.log("Creating Teqtank Commerce runtime:", {
        version: TEQTANK_COMMERCE_SDK_VERSION,
        commerceKey: configuration.commerceKey,
        dataSource: configuration.dataSource,
    });
    return TeqtankCommerce.initialize(configuration);
}
